


































import { Validator } from 'vee-validate'
import Vue from 'vue'
import { Component, Inject, Prop } from 'vue-property-decorator'

@Component
export default class InputFormKana extends Vue {
  @Inject()
  $validator: Validator

  @Prop({ required: true })
  lastKana: string

  @Prop({ required: true })
  firstKana: string

  @Prop({ required: true })
  input: (value: string, field: string) => void
}
